export const TimeZoneData = [
    {
        "tzDatabaseName": "Africa/Abidjan",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Accra",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Addis_Ababa",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Algiers",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Asmara",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Bamako",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    }, 
    {
        "tzDatabaseName": "Africa/Bangui",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Banjul",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Bissau",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Blantyre",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Brazzaville",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Bujumbura",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Cairo",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Casablanca",
        "utcStd": "+01:00",
        "utcDst": "+00:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Africa/Ceuta",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Africa/Conakry",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Dakar",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Dar_es_Salaam",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Djibouti",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Douala",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/El_Aaiun",
        "utcStd": "+01:00",
        "utcDst": "+00:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Africa/Freetown",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Gaborone",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Harare",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Johannesburg",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Juba",
        "utcStd": "+02:06",
        "utcDst": "+02:06",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Kampala",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Khartoum",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Kigali",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Kinshasa",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Lagos",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Libreville",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Lome",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Luanda",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Lubumbashi",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Lusaka",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Malabo",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Maputo",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Maseru",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Mbabane",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Mogadishu",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Monrovia",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Nairobi",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Ndjamena",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Niamey",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Nouakchott",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Ouagadougou",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Porto-Novo",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Sao_Tome",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
	{
        "tzDatabaseName": "Africa/Tripoli",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Tunis",
        "utcStd": "+01:00",
        "utcDst": "+01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Africa/Windhoek",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Adak",
        "utcStd": "-10:00",
        "utcDst": "-09:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Anchorage",
        "utcStd": "-09:00",
        "utcDst": "-08:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Anguilla",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Antigua",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Araguaina",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Buenos_Aires",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Catamarca",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Cordoba",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Jujuy",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/La_Rioja",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Mendoza",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Rio_Gallegos",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Salta",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/San_Juan",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/San_Luis",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Tucuman",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Argentina/Ushuaia",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Aruba",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Asuncion",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Atikokan",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Bahia",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Bahia_Banderas",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Barbados",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Belem",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Belize",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Blanc-Sablon",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Boa_Vista",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Bogota",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Boise",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Cambridge_Bay",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Campo_Grande",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Cancun",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Caracas",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Cayenne",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Cayman",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Chicago",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Chihuahua",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Costa_Rica",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Creston",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Cuiaba",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Curacao",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Danmarkshavn",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Dawson",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Dawson_Creek",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Denver",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Detroit",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Dominica",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Edmonton",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Eirunepe",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/El_Salvador",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
	{
        "tzDatabaseName": "America/El_Salvador",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Fort_Nelson",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Fortaleza",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Glace_Bay",
        "utcStd": "-04:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Goose_Bay",
        "utcStd": "-04:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Grand_Turk",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Grenada",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Guadeloupe",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Guatemala",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Guayaquil",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Guyana",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Halifax",
        "utcStd": "-04:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Havana",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Hermosillo",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Indiana/Indianapolis",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Indiana/Knox",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Indiana/Marengo",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Indiana/Petersburg",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Indiana/Tell_City",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Indiana/Vevay",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Indiana/Vincennes",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Indiana/Winamac",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Inuvik",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Iqaluit",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Jamaica",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Juneau",
        "utcStd": "-09:00",
        "utcDst": "-08:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Kentucky/Louisville",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Kentucky/Monticello",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Kralendijk",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/La_Paz",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Lima",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Los_Angeles",
        "utcStd": "-08:00",
        "utcDst": "-07:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Lower_Princes",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Maceio",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Managua",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Manaus",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Marigot",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Martinique",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Matamoros",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Mazatlan",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Menominee",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Merida",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Metlakatla",
        "utcStd": "-09:00",
        "utcDst": "-08:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Mexico_City",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Miquelon",
        "utcStd": "-03:00",
        "utcDst": "-02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Moncton",
        "utcStd": "-04:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Monterrey",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Montevideo",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Montserrat",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Nassau",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/New_York",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Nome",
        "utcStd": "-09:00",
        "utcDst": "-08:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Noronha",
        "utcStd": "-02:00",
        "utcDst": "-02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/North_Dakota/Beulah",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/North_Dakota/Center",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/North_Dakota/New_Salem",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Nuuk",
        "utcStd": "-03:00",
        "utcDst": "-02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Ojinaga",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Panama",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Pangnirtung",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Paramaribo",
        "utcStd": "-03:40",
        "utcDst": "-03:40",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Phoenix",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
	 {
        "tzDatabaseName": "America/Port_of_Spain",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Port-au-Prince",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Porto_Velho",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Puerto_Rico",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Punta_Arenas",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Rankin_Inlet",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Recife",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Regina",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Resolute",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Rio_Branco",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Santarem",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Santiago",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Santo_Domingo",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Sao_Paulo",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Scoresbysund",
        "utcStd": "-01:00",
        "utcDst": "-00:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Sitka",
        "utcStd": "-09:00",
        "utcDst": "-08:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/St_Barthelemy",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/St_Johns",
        "utcStd": "-03:30",
        "utcDst": "-02:30",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/St_Kitts",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/St_Lucia",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/St_Thomas",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/St_Vincent",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Swift_Current",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Tegucigalpa",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Thule",
        "utcStd": "-04:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Tijuana",
        "utcStd": "-08:00",
        "utcDst": "-07:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Toronto",
        "utcStd": "-05:00",
        "utcDst": "-04:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Tortola",
        "utcStd": "-04:00",
        "utcDst": "-04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Vancouver",
        "utcStd": "-08:00",
        "utcDst": "-07:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Whitehorse",
        "utcStd": "-07:00",
        "utcDst": "-07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "America/Winnipeg",
        "utcStd": "-06:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Yakutat",
        "utcStd": "-09:00",
        "utcDst": "-08:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "America/Yellowknife",
        "utcStd": "-07:00",
        "utcDst": "-06:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Antarctica/Casey",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/Davis",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/DumontDUrville",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/Macquarie",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Antarctica/Mawson",
        "utcStd": "+05:00",
        "utcDst": "-+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/McMurdo",
        "utcStd": "+13:00",
        "utcDst": "+13:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/Palmer",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/Rothera",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/Syowa",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Antarctica/Troll",
        "utcStd": "+02:00",
        "utcDst": "+00:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Antarctica/Vostok",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Arctic/Longyearbyen",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Aden",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Almaty",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Amman",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Anadyr",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Aqtau",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Aqtobe",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Ashgabat",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Atyrau",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Baghdad",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Bahrain",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Baku",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Bangkok",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Barnaul",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Beirut",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Bishkek",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Brunei",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Chita",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Choibalsan",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Colombo",
        "utcStd": "+05:30",
        "utcDst": "+05:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Damascus",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Dhaka",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Dili",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Dubai",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Dushanbe",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Famagusta",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Gaza",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Hebron",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Ho_Chi_Minh",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Hong_Kong",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Hovd",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Irkutsk",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Jakarta",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Jayapura",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Jerusalem",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Kabul",
        "utcStd": "+04:30",
        "utcDst": "+04:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Kamchatka",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Karachi",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Kathmandu",
        "utcStd": "+05:45",
        "utcDst": "+05:45",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Khandyga",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Kolkata",
        "utcStd": "+05:30",
        "utcDst": "+05:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Krasnoyarsk",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Kuala_Lumpur",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Kuching",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Kuwait",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Macau",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Magadan",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Makassar",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Manila",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Muscat",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Nicosia",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Novokuznetsk",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Novosibirsk",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Omsk",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Oral",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Phnom_Penh",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Pontianak",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Pyongyang",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Qatar",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Qostanay",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Qyzylorda",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Riyadh",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Sakhalin",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Samarkand",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Seoul",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Shanghai",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Singapore",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Srednekolymsk",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Taipei",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Tashkent",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Tbilisi",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Tehran",
        "utcStd": "+03:30",
        "utcDst": "+04:30",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Asia/Thimphu",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Tokyo",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Tomsk",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Ulaanbaatar",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Urumqi",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Ust-Nera",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Vientiane",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Vladivostok",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Yakutsk",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Yangon",
        "utcStd": "+06:30",
        "utcDst": "+06:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Yekaterinburg",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Asia/Yerevan",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Atlantic/Azores",
        "utcStd": "-01:00",
        "utcDst": "+00:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Atlantic/Bermuda",
        "utcStd": "-04:00",
        "utcDst": "-03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Atlantic/Canary",
        "utcStd": "+00:00",
        "utcDst": "-01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Atlantic/Cape_Verde",
        "utcStd": "−01:00",
        "utcDst": "−01:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Atlantic/Faroe",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Atlantic/Madeira",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Atlantic/Reykjavik",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Atlantic/South_Georgia",
        "utcStd": "-02:00",
        "utcDst": "-02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Atlantic/St_Helena",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Atlantic/Stanley",
        "utcStd": "-03:00",
        "utcDst": "-03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Adelaide",
        "utcStd": "+10:30",
        "utcDst": "+10:30",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Australia/Brisbane",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Broken_Hill",
        "utcStd": "+09:30",
        "utcDst": "+10:30",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Australia/Darwin",
        "utcStd": "+09:30",
        "utcDst": "+09:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Eucla",
        "utcStd": "+08:45",
        "utcDst": "+08:45",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Hobart",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Lindeman",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Lord_Howe",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Australia/Melbourne",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Australia/Perth",
        "utcStd": "+08:00",
        "utcDst": "+08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Australia/Sydney",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Amsterdam",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Andorra",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Astrakhan",
        "utcStd": "+04:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Athens",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Belgrade",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Berlin",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Bratislava",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Brussels",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Bucharest",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Budapest",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Busingen",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Chisinau",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Copenhagen",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Dublin",
        "utcStd": "+00:00",
        "utcDst": "+00:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Gibraltar",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Guernsey",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Helsinki",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Isle_of_Man",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Istanbul",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Jersey",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Kaliningrad",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Kirov",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Kyiv",
        "utcStd": "+02:00",
        "utcDst": "+02:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Lisbon",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Ljubljana",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/London",
        "utcStd": "+00:00",
        "utcDst": "+01:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Luxembourg",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Madrid",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Malta",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Mariehamn",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Minsk",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Monaco",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Moscow",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Oslo",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Paris",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Podgorica",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Prague",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Riga",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Rome",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Samara",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/San_Marino",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Sarajevo",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Saratov",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Simferopol",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Skopje",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Sofia",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Stockholm",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Tallinn",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Tirane",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Ulyanovsk",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Vaduz",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Vatican",
        "utcStd": "+01:00",
        "utcDst": "+092:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Vienna",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Vilnius",
        "utcStd": "+02:00",
        "utcDst": "+03:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Volgograd",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Europe/Warsaw",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Zagreb",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Europe/Zurich",
        "utcStd": "+01:00",
        "utcDst": "+02:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Indian/Antananarivo",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Chagos",
        "utcStd": "+06:00",
        "utcDst": "+06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Christmas",
        "utcStd": "+07:00",
        "utcDst": "+07:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Cocos",
        "utcStd": "+06:30",
        "utcDst": "+06:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Comoro",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Kerguelen",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Mahe",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Maldives",
        "utcStd": "+05:00",
        "utcDst": "+05:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Mauritius",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Mayotte",
        "utcStd": "+03:00",
        "utcDst": "+03:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Indian/Reunion",
        "utcStd": "+04:00",
        "utcDst": "+04:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Apia",
        "utcStd": "+13:00",
        "utcDst": "+13:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Auckland",
        "utcStd": "+13:00",
        "utcDst": "+13:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Pacific/Bougainville",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Chatham",
        "utcStd": "+13:45",
        "utcDst": "+13:45",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Pacific/Chuuk",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Easter",
        "utcStd": "-05:00",
        "utcDst": "-05:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Pacific/Efate",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Fakaofo",
        "utcStd": "+13:00",
        "utcDst": "+13:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Fiji",
        "utcStd": "+12:00",
        "utcDst": "+13:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Pacific/Funafuti",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Galapagos",
        "utcStd": "-06:00",
        "utcDst": "-06:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Gambier",
        "utcStd": "-09:00",
        "utcDst": "-09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Guadalcanal",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Guam",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Honolulu",
        "utcStd": "-10:00",
        "utcDst": "-10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Kanton",
        "utcStd": "+13:00",
        "utcDst": "+13:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Kiritimati",
        "utcStd": "+14:00",
        "utcDst": "+14:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Kosrae",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Kwajalein",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Majuro",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Marquesas",
        "utcStd": "-09:30",
        "utcDst": "-09:30",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Midway",
        "utcStd": "-11:00",
        "utcDst": "-11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Nauru",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Niue",
        "utcStd": "-11:00",
        "utcDst": "-11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Norfolk",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": true
    },
    {
        "tzDatabaseName": "Pacific/Noumea",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Pago_Pago",
        "utcStd": "-11:00",
        "utcDst": "-11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Palau",
        "utcStd": "+09:00",
        "utcDst": "+09:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Pitcairn",
        "utcStd": "-08:00",
        "utcDst": "-08:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Pohnpei",
        "utcStd": "+11:00",
        "utcDst": "+11:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Port_Moresby",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Rarotonga",
        "utcStd": "-10:00",
        "utcDst": "-10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Saipan",
        "utcStd": "+10:00",
        "utcDst": "+10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Tahiti",
        "utcStd": "-10:00",
        "utcDst": "-10:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Tarawa",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Tongatapu",
        "utcStd": "+13:00",
        "utcDst": "+13:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Wake",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    },
    {
        "tzDatabaseName": "Pacific/Wallis",
        "utcStd": "+12:00",
        "utcDst": "+12:00",
        "dstObserved": false
    }
]